import { render, staticRenderFns } from "./AgilityMonitoring.vue?vue&type=template&id=4a44af52&"
import script from "./AgilityMonitoring.vue?vue&type=script&lang=js&"
export * from "./AgilityMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports